var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.75,
    height: 19.375,
    viewBox: "0 0 23.75 19.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13252",
    "data-name": "Grupo 13252",
    transform: "translate(-107.25 -313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13250",
    "data-name": "Grupo 13250",
    transform: "translate(-0.5 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_400",
    "data-name": "Trazado 400",
    d: "M7.312-40.75H11.97a2.54,2.54,0,0,1,2.369,1.641l.277.734h2.747a2.534,2.534,0,0,1,2.531,2.531v10.688a2.534,2.534,0,0,1-2.531,2.531H1.924A2.534,2.534,0,0,1-.607-25.156V-35.844a2.534,2.534,0,0,1,2.531-2.531H4.669l.274-.734A2.54,2.54,0,0,1,7.312-40.75ZM17.362-24.125a1.032,1.032,0,0,0,1.031-1.031V-35.844a1.032,1.032,0,0,0-1.031-1.031H13.577l-.643-1.706a1.034,1.034,0,0,0-.964-.669H7.312a1.033,1.033,0,0,0-.964.667L5.71-36.875H1.924A1.032,1.032,0,0,0,.893-35.844v10.688a1.032,1.032,0,0,0,1.031,1.031Z",
    transform: "translate(108.357 356)",
    fill: "#3743aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14611",
    "data-name": "Trazado 14611",
    d: "M4,1.5A2.5,2.5,0,1,0,6.5,4,2.5,2.5,0,0,0,4,1.5M4,0A4,4,0,1,1,0,4,4,4,0,0,1,4,0Z",
    transform: "translate(114 321.313)",
    fill: "#3743aa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13251",
    "data-name": "Grupo 13251",
    transform: "translate(-0.5 -2.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_139",
    "data-name": "Elipse 139",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(123.5 315.5)",
    fill: "#3743aa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13248",
    "data-name": "Grupo 13248",
    transform: "translate(125 317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_260",
    "data-name": "L\\xEDnea 260",
    d: "M.5,5h-1V0h1Z",
    transform: "translate(2.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_261",
    "data-name": "L\\xEDnea 261",
    d: "M5,.5H0v-1H5Z",
    transform: "translate(0 2.5)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon-add.835dd095c4373641da2e9ae9b1fcf084.svg";
export { ForwardRef as ReactComponent };